<template>
  <g>
    <path
      d="M6 4.01024C3.58 5.84024 2 8.73024 2 12.0002C2 13.4602 2.32 14.8502 2.89 16.1102L6 14.3102V4.01024Z"
    />
    <path
      d="M11 11.4202V2.05024C9.94 2.16024 8.93 2.43024 8 2.84024V13.1602L11 11.4202Z"
    />
    <path
      d="M12 13.1502L3.89001 17.8302C4.50001 18.6702 5.23001 19.4202 6.07001 20.0302L15 14.8902L12 13.1502Z"
    />
    <path
      d="M13 7.96024V11.4202L21.11 16.1002C21.53 15.1702 21.81 14.1702 21.93 13.1202L13 7.96024Z"
    />
    <path
      d="M8.07001 21.2002C9.28001 21.7102 10.6 22.0002 12 22.0002C15.34 22.0002 18.29 20.3502 20.11 17.8402L17 16.0402L8.07001 21.2002Z"
    />
    <path
      d="M21.92 10.8102C21.37 6.18024 17.66 2.51024 13 2.05024V5.65024L21.92 10.8102Z"
    />
  </g>
</template>
